// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--42444";
export var btn = "style-module--btn--71e9e";
export var container = "style-module--container--38087";
export var develop = "style-module--develop--2ffdf";
export var experts = "style-module--experts--cd3da";
export var gray = "style-module--gray--b3061";
export var logo = "style-module--logo--261e0";
export var orange = "style-module--orange--a2ae9";
export var violet = "style-module--violet--08356";